import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import VideocamIcon from "@material-ui/icons/Videocam";
import VideocamOffIcon from "@material-ui/icons/VideocamOff";

export const VideoCallButton = ({ nonAvailablePersons, videoRequest, badgeNo, connectionList, videoCallActive, tooltipTitle }) => {
  const notAvailable = nonAvailablePersons.find((na) => na == badgeNo);
  const isOnline = connectionList.find((c) => c.clientKey == badgeNo);
  return (
    <IconButton disabled={notAvailable || videoCallActive || !isOnline} onClick={() => videoRequest(badgeNo)}>
      <Tooltip title={tooltipTitle}>{notAvailable || !isOnline ? <VideocamOffIcon /> : <VideocamIcon />}</Tooltip>
    </IconButton>
  );
};
